/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:26:03
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title9 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';

class P21 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  render() {
    const { chartTitle, chartList, chartColorList } = this.state;
    return (
      <Stage>
        <Title9 pageNumber="5">负面话题点及正面修复程度分析</Title9>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.subTitle}>负面内容条数多，但正面内容力度大</div>
            <div contentEditable className={s.des}>
            由司马南事件引发的负面话题点主要有#国有资产流失#、#外籍高管#、#技术空心化#、#金融业务#、#干涉媒体舆论#、#5G投票高通#、#滴滴下架#等。负面舆论最高的三个话题是#国有资产流失#、#外籍高管#以及#高管薪酬过高#。值得一提的是，#国有资产流失#、#外籍高管#、#技术空心化#三个话题，虽正面内容条数大幅少于负面，但经过修复后，正面口碑超过负面，说明正面言论“一文胜千篇”。
            </div>
          </div>
          <div className={s.chartWrapper}>
            <TooltipDrawer
              style={{ width: '100%', height: '100%' }}
              formContent={<Form onChange={values => this.setState({ ...values })} />}>
              <Chart isShow options={setChart({
                label: chartTitle,
                list: chartList,
                color: chartColorList
              })} />
            </TooltipDrawer>
          </div>
          <div contentEditable className={s.explain}>数据说明：本页图表数据观测窗口为2021年1月1日-11月30日，数据来源：新闻网站类+自媒体平台（微信号等）+社交平台（微博/知乎等）+新闻客户端（今日头条/一点资讯等）+短视频类（抖音/快手/B站）+股票平台（雪球/东方财富网/同花顺财经/富途）+其它论坛贴吧等。</div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P21);



// WEBPACK FOOTER //
// src/routes/visualChart/P21/index.js